import {request} from "@/services/fetch"

export async function getNotificacoes(clinicaId, limit = 20) {
  const qs = new URLSearchParams();
  if (clinicaId) qs.set("clinicaId", clinicaId);
  qs.set("limit", String(limit));
  return request(`api/notificacoes?${qs.toString()}`);
}

export async function getNotification(id) {
  return request(`api/notificacoes/${encodeURIComponent(id)}`);
}

export async function markAsRead(id) {
  return request(`api/notificacoes/${encodeURIComponent(id)}/read`, { method: "POST" });
}

export async function markAllAsRead(clinicaId) {
  const qs = new URLSearchParams();
  if (clinicaId) qs.set("clinicaId", clinicaId);
  return request(`api/notificacoes/read-all?${qs.toString()}`, { method: "POST" });
}
